export enum FieldImportance {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  EXTRA = 'EXTRA',
}
